import Button from "@mui/material/Button";
import Testo from "../elementi/Testo";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { monFetch, isAdminGlobale, isIntervistatoreAutonomo, isIntervistatore } from "../inc/inc";
import Cookies from "js-cookie";
import AutocompleteMon from "../elementi/AutocompleteMon";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
import CheckBoxMon from "../elementi/CheckBoxMon";

const Comp = (props) => {
  //const ruoloLogin = controllaLogin();
  let params = useParams();

  let id = params.id;
  //se sono in pagina di modifica utente loggato
  if (props.utenteLoggato) {
    id = Cookies.get("id");
  }

  const [clienti, setClienti] = useState([]);
  const [optionsClienti, setOptionsClienti] = useState([]);

  const [sezioni, setSezioni] = useState([]);
  const [optionsSezioni, setOptionsSezioni] = useState([]);

  const [nome, setNome] = useState("");
  const [cognome, setCognome] = useState("");
  const [email, setEmail] = useState("");
  const [attivo, setAttivo] = useState(false);
  const [livelloAdmin, setLivelloAdmin] = useState(0);
  const [c2fa, setC2fa] = useState(false);

  const [viewPdfCli, setViewPdfCli] = useState(false);
  const [viewPdfAud, setViewPdfAud] = useState(false);
  const [viewPdfCom, setViewPdfCom] = useState(false);

  const [optionsLivello, setOptionsLivello] = useState([]);

  async function queryUtente(id) {
    const res = await monFetch("/userGet", {
      id: id,
    });
    const user = res.user;
    setNome(user.first_name);
    setCognome(user.last_name);
    setEmail(user.email);
    setAttivo(user.enabled ? true : false);
    setLivelloAdmin(user.admin_level);
    setC2fa(user.enabled2fa ? true : false);
    setViewPdfCli(user.view_pdf_cli ? true : false);
    setViewPdfAud(user.view_pdf_aud ? true : false);
    setViewPdfCom(user.view_pdf_com ? true : false);

    //clienti associati a utente
    const temp = [];
    user.customers.forEach((el) => {
      temp.push(el.customer_id);
    });
    setClienti(temp);

    ///sezioni associate
    const temp2 = [];
    user.sections.forEach((el) => {
      temp2.push(el.section_id);
    });
    setSezioni(temp2);
  }

  async function queryLivelliAdmin() {
    const res = await monFetch("/adminLevelList", {});
    const livelliAdmin = [];
    res.level.forEach((el) => {
      livelliAdmin.push({ label: el.level, value: el.id });
    });
    setOptionsLivello(livelliAdmin);
  }

  async function salvaUtente(e, id) {
    e.preventDefault();

    const data = {
      id: id,
      email: email,
      first_name: nome,
      last_name: cognome,
      active: attivo ? 1 : 0,
      // roles: ruoliUtenteSalva,
      customerIds: clienti,
      sectionIds: sezioni,
      admin_level: livelloAdmin,
      // company_id: azienda,
      enabled2fa: c2fa,
      viewPdfCli: viewPdfCli,
      viewPdfAud: viewPdfAud,
      viewPdfCom: viewPdfCom,
    };

    const res = await monFetch("/userSet", data);
    // return
    if (res.success) {
      if (res.id) {
        window.location.href = process.env.PUBLIC_URL + "/utenti";
      } else {
        window.location.href = process.env.PUBLIC_URL + "/utenti";
      }
    }
  }

  async function queryClienti(e) {
    const res = await monFetch("/customerList", {});
    const temp = [];
    /*  console.log(res); */
    res.customer.forEach((el) => {
      temp.push({
        label: el.businessName,
        value: el.id,
      });
    });
    setOptionsClienti(temp);
  }

  async function querySezioni(e) {
    const res = await monFetch("/sectionList", {});

    const temp = [];
    res.section.forEach((el) => {
      temp.push({
        label: el.name,
        value: el.id,
      });
    });
    setOptionsSezioni(temp);
  }

  useEffect(() => {
    props.setTestoTitolo(props.nuovo ? "Aggiungi Utente" : "Modifica Utente");

    queryLivelliAdmin();
    queryClienti();
    querySezioni();

    if (id) {
      queryUtente(id);
    }
  }, []);

  return (
    <form onSubmit={(e) => salvaUtente(e, id)}>
      <Grid container spacing={2}>
        <Grid item sm={4} xs={12}>
          <Testo
            label="Email"
            required
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            label="Nome"
            required
            value={nome}
            onChange={(e) => {
              setNome(e.target.value);
            }}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            label="Cognome"
            required
            value={cognome}
            onChange={(e) => {
              setCognome(e.target.value);
            }}
          />
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={2}>
        {isAdminGlobale() && (
          <Grid item sm={4} xs={12}>
            <h4>Livello Admin</h4>
            <AutocompleteMon
              value={
                optionsLivello.find((op) => op.value == livelloAdmin) || null
              }
              onChange={(e, value) => {
                console.log("change autoc", value);
                if (!value) {
                  return;
                }
                setLivelloAdmin(value.value);
              }}
              options={optionsLivello}
              label="Livello"
              inputRequired={true}
            />
          </Grid>
        )}

        <Grid item sm={3} xs={12}>
          <h4>Autenticazione a 2 fattori: {c2fa ? "Attiva" : "Disattivata"}</h4>
          {c2fa == true ? (
            <></>
          ) : //mostro solo se sono nella pagina dell'utente loggato
          props.utenteLoggato ? (
            <Button
              className="buttonSuccess"
              href={process.env.PUBLIC_URL + "/abilita2fa"}
              variant="contained"
            >
              Attiva 2FA
            </Button>
          ) : (
            "L'utente deve attivare la 2FA."
          )}
          <br />
          <br />
        </Grid>
        {isAdminGlobale() && (
          <Grid item sm={12} xs={12}>
            <CheckBoxMon
              className="paddingSez"
              checked={attivo}
              onChange={(e) => setAttivo(e.target.checked)}
              label={"Attivo"}
            />
          </Grid>
        )}

        {isAdminGlobale() && (
          <>
            <Grid item sm={12} xs={12}>
              <div className="sectionBar paddingSez">
                <h4>Associa Clienti</h4>
                <FormControl fullWidth size="small">
                  <InputLabel>Lista Clienti</InputLabel>
                  <Select
                    multiple
                    fullWidth
                    label="Lista clienti"
                    value={clienti}
                    onChange={(e) => {
                      setClienti(e.target.value);
                    }}
                  >
                    {optionsClienti.map((el, index) => (
                      <MenuItem key={index} value={el.value}>
                        {el.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </Grid>

            {(isIntervistatoreAutonomo(livelloAdmin) ||
              isIntervistatore(livelloAdmin)) && (
              <>
                <Grid item sm={12} xs={12}>
                  <div className="sectionBar paddingSez">
                    <h4>Associa Sezioni</h4>
                    <FormControl fullWidth size="small">
                      <InputLabel>Sezioni</InputLabel>
                      <Select
                        multiple
                        fullWidth
                        label="Sezioni"
                        value={sezioni || ""}
                        onChange={(e) => {
                          setSezioni(e.target.value);
                        }}
                      >
                        {optionsSezioni.map((el) => (
                          <MenuItem key={el.value} value={el.value}>
                            {el.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </Grid>
                <Grid item sm={12} xs={12}>
                  <div className="sectionBar paddingSez">
                    <h4>Permessi PDF</h4>
                    <div style={{ display: "flex" }}>
                      <CheckBoxMon
                        className="paddingSez"
                        checked={viewPdfCli}
                        onChange={(e) => setViewPdfCli(e.target.checked)}
                        label={"Pdf Cliente"}
                      />
                      <CheckBoxMon
                        className="paddingSez"
                        checked={viewPdfAud}
                        onChange={(e) => setViewPdfAud(e.target.checked)}
                        label={"Relazione completa"}
                      />
                      <CheckBoxMon
                        className="paddingSez"
                        checked={viewPdfCom}
                        onChange={(e) => setViewPdfCom(e.target.checked)}
                        label={"Relazione commerciale"}
                      />
                    </div>
                  </div>
                </Grid>
              </>
            )}
          </>
        )}
        <Grid item sm={12} xs={12} style={{ textAlign: "right" }}>
          <div className="flexSpaceBetween">
            <Button
              className="buttonIndietro"
              href={process.env.PUBLIC_URL + "/utenti"}
              variant="contained"
            >
              Indietro
            </Button>
            <Button className="buttonSalva" type="submit" variant="contained">
              Salva
            </Button>
          </div>
        </Grid>
      </Grid>
    </form>
  );
};

export default Comp;
